import type { SVGProps } from 'react'
const SvgSyTimeProgress = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M12 3.3c0-.142 0-.214.046-.258.045-.044.115-.042.254-.037a9 9 0 1 1-8.25 4.778c.064-.123.097-.184.158-.202s.123.018.246.089l5.547 3.183c.118.068.177.102.196.154.018.053-.01.124-.065.266a2.005 2.005 0 1 0 2.167-1.255c-.151-.023-.226-.034-.263-.076C12 9.9 12 9.832 12 9.696z"
		/>
		<path d="M8.65 17.802c-.071.124-.107.186-.09.247.019.061.08.094.203.158a7 7 0 1 0 3.537-13.2c-.138-.007-.207-.01-.254.035C12 5.086 12 5.157 12 5.3v4.402c0 .136 0 .204.036.246.037.043.112.054.263.077a2 2 0 0 1 1.63 2.492 1.997 1.997 0 0 1-2.658 1.343c-.142-.056-.213-.083-.265-.065s-.087.077-.155.195z" />
	</svg>
)
export default SvgSyTimeProgress
